import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Box, Button, withStyles, Paper, TextField, Popper, Fade, Typography,
} from '@material-ui/core';
import { ArrowBackIos as ArrowBackIosIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { MUIEditorState } from 'react-mui-draft-wysiwyg';
import FormTitle from '../../../../components/atoms/formTitle/FormTitle';
import FormErrorText from '../../../../components/atoms/formErrorText/FormErrorText';
import Wysiwyg from '../../../../components/atoms/wysiwyg/Wysiwyg';

// #region css
const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(10),
    paddingBottom: theme.spacing(5),
  },
  textCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginRight: '20px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '20px',
      marginBottom: '20px',
    },
  },
  popper: {
    paddingTop: '10px',
  },
  popperText: {
    backgroundColor: 'rgba(0,0,0,.05)',
    boxShadow: '0 -8px 10px -9px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.01), 0 5px 5px -3px rgba(0,0,0,.05)',
  },
  footer: {
    zIndex: '1000',
    width: '100%!important',
    position: 'fixed!important',
    bottom: '0',
    left: '0',
    background: '#fff',
    boxShadow: '0 -8px 10px -9px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.01), 0 5px 5px -3px rgba(0,0,0,.05)',
  },
});
// #endregion

const COPYTEXT = {
  会員番号: 'memberNo',
  姓: 'memberLastName',
  名: 'memberFirstName',
  姓フリガナ: 'memberLastNameKana',
  名フリガナ: 'memberFirstNameKana',
};

class Content extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  scrollToTop = () => window.scrollTo(0, 0);

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    const text = COPYTEXT[event.target.textContent];
    const placeholder = `%${text}%`;
    navigator.clipboard.writeText(placeholder).then(() => {
      this.setMessage('クリップボードにコピーしました。');
    }).catch(() => {
      this.setMessage('クリップボードへのコピーに失敗しました。');
    });
  }

  setMessage = (message) => {
    this.setState({
      open: true,
      message,
    });

    setTimeout(() => {
      this.setState({
        open: false,
        message: '',
        anchorEl: null,
      });
    }, 1000);
  }

  handleChange = (e) => {
    this.props.onChange(e, this.props.type);
  }

  handleBack = () => {
    const { type, activeStep } = this.props;
    this.props.onChangeStep(type, activeStep - 1);
  }

  hasError = () => {
    const { errorMessage } = this.props;
    return Object.values(errorMessage).some((v) => v !== '');
  }

  handleSave = () => {
    this.props.onSave(this.props.type);
  }

  render() {
    const {
      classes,
      data,
      errorMessage,
      fromDetail,
    } = this.props;

    const {
      open,
      anchorEl,
      message,
    } = this.state;

    return (
      <div className={classes.root}>
        <Box my={3}>
          <Alert style={{ display: this.hasError() ? '' : 'none' }} severity="error">入力エラーがあります。確認してください。</Alert>
        </Box>

        <Paper elevation={0} variant="outlined">
          <Box p={3}>
            <Box mb={3}>
              <FormTitle title="置換タグ" />
              <Button className={classes.button} onClick={this.handleClick} variant="contained">会員番号</Button>
              <Button className={classes.button} onClick={this.handleClick} variant="contained">姓</Button>
              <Button className={classes.button} onClick={this.handleClick} variant="contained">名</Button>
              <Button className={classes.button} onClick={this.handleClick} variant="contained">姓フリガナ</Button>
              <Button className={classes.button} onClick={this.handleClick} variant="contained">名フリガナ</Button>
              <Popper className={classes.popper} open={open} anchorEl={anchorEl} transition placement="bottom-start">
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper>
                      <Typography className={classes.popperText}>{message}</Typography>
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </Box>
            <Box mb={3}>
              <FormTitle title="件名" isRequired />
              <TextField
                name="subject"
                id="subject"
                variant="outlined"
                onChange={this.handleChange}
                autoComplete="off"
                value={data.subject}
                error={errorMessage.subject !== ''}
                inputProps={{ maxLength: 50 }}
                fullWidth
              />
              <FormErrorText>{errorMessage.subject}</FormErrorText>
            </Box>

            <Box mb={3}>
              <FormTitle title="本文" isRequired />
              <Wysiwyg
                onChange={this.handleChange}
                value={data.body ?? MUIEditorState.createEmpty()}
                name="body"
              />
              <FormErrorText>{errorMessage.body}</FormErrorText>
            </Box>
          </Box>
        </Paper>

        <Box position="fixed" pb={2} className={classes.footer}>
          <Box align="center" textAlign="center" mt={2} display={{ xs: 'block', sm: 'flex' }} justifyContent="center">
            {!fromDetail && (
              <Button
                variant="contained"
                onClick={this.handleBack}
                startIcon={<ArrowBackIosIcon />}
                className={classes.button}
              >
                戻る
              </Button>
            )}
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleSave}
              endIcon={null}
              className={classes.button}
            >
              保存
            </Button>
          </Box>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  entry: state.entry,
  common: state.common,
});

export default withStyles(styles)(withRouter(connect(mapStateToProps)(Content)));
